import { useMemo, useEffect } from "react";
import { CircularProgress, Grid } from "@newulife/common";
import SiteNavBar from "components/navbars/SiteNavBar";
import { Stack } from "@newulife/common";
import { useContentfulContext, ContentfulProvider } from "hooks/useContentful";
import { useLanguages } from "hooks/useLanguages";
import { useLocation } from "react-router-dom";
import { useApp } from "contexts/AppContext";
import { get } from "api/request";
import { apiClient } from "api/api";
import KoreaVerification from "./KoreaVerification";
import TermsVerification from "./TermsVerification";
import MalaysiaVerification from "./MalaysiaVerification";

const VerificationPage = () => {
  const { search } = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(search.replace(/&amp;/g, "&")),
    [search]
  );
  const guid = searchParams.get("guid");
  const checkterms = searchParams.get("checkterms");
  const market = searchParams.get("market");
  const { headTagModelRef } = useContentfulContext({ entryPoint: "fields" });
  const {
    state: { rep, isLoading, languages: stateLanguages },
  } = useApp();
  const { dispatch } = useApp();

  // Load languages by rep's billing country so the language selector shows correct options
  useLanguages();

  useEffect(() => {
    const validateGuid = async () => {
      try {
        const res = await get(`/api/profile/autoresponder-details?requestedTerms=${checkterms === "1"}&sessionIdentifier=${guid}`);
        if (res?.token) {
          apiClient.defaults.headers.Authorization = `Bearer ${res.token}`;
        }
        dispatch({
          type: "updateRep",
          rep: res,
        });
      } catch (e) {
        console.log(e);
      }
    };
    if (guid) validateGuid();
  }, [guid, checkterms, market, stateLanguages, dispatch]);

  return (
    <>
      {isLoading && (
        <Grid
          sx={{
            minHeight: "100vh",
            width: "100vw",
          }}
          container
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Grid>
      )}
      <Stack
        gap={3}
        alignItems="center"
        py={10}
        bgcolor="neutralCool.lightest"
        minHeight="100vh"
        width="100vw"
      >
        <SiteNavBar data={headTagModelRef} hideNav />
        {rep.country === 'KOREA (THE REPUBLIC OF)' ? ( // Profile - Korea Verification Page
          <ContentfulProvider id="30tiQgbHuWJjyEPH6mx80G"> 
            <KoreaVerification />
          </ContentfulProvider>
        ) : 
        (market === 'MALAYSIA' || rep.country === 'MALAYSIA' ) ? (
          <ContentfulProvider id="5UzGadp9msS2dcQbHYM8C0">
            <MalaysiaVerification />
          </ContentfulProvider>
        ) : (
          <ContentfulProvider id="7lU1kbZdai43zxeNjDErwP">
            <TermsVerification />
          </ContentfulProvider>
        )}
      </Stack>
    </>
  );
};

export default VerificationPage;
